import { FILTER_TO_MODE } from "@/lib/constants";

export const detectMode = (input) => {
  const s = (input || "").trim();
  if (!s) return null;
  if (s === "latest") return { mode: "blocks", value: s };
  if (/^stake(_test)?1[a-z0-9]+$/.test(s)) return { mode: "accounts", value: s };
  if (/^addr(_test)?1[a-z0-9]+$/.test(s)) return { mode: "addresses", value: s };
  if (/^pool1[a-z0-9]+$/.test(s)) return { mode: "pools", value: s };
  if (/^\d+$/.test(s)) return { mode: "blocks", value: s };
  if (/^[0-9a-f]{64}$/.test(s)) return { mode: "transactions", value: s };
  if (/^[0-9a-f]{56}([0-9a-f]{2})*$/.test(s) && s.length >= 56 && s.length <= 120 && s.length % 2 === 0) {
    return { mode: "assets", value: s };
  }
  return null;
};

export const resolveSearch = (input, filterKey) => {
  const s = (input || "").trim();
  if (!s) return { mode: null, error: "Type something to search." };
  if (filterKey === "all") {
    const det = detectMode(s);
    if (det) return det;
    return { mode: null, error: "Couldn't auto-detect the type. Try a filter pill." };
  }
  const targetMode = FILTER_TO_MODE[filterKey];
  if (targetMode === null) {
    const labels = { pools: "Pools", epochs: "Epochs", metadata: "Metadata" };
    return { mode: null, error: `${labels[filterKey] || filterKey} search is coming soon.` };
  }
  return { mode: targetMode, value: s };
};
